export enum TEXTAREA_TEST_IDS {
	ROOT = 'TEXTAREA_ROOT',
	INPUT = 'TEXTAREA_INPUT',
	LABEL = 'TEXTAREA_LABEL',
}
